
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import LazyImage from "./LazyImage.vue";
import { NeighboorhoodCoords, NeighborhoodPlanQmiCounts, NeighborhoodPlatMap, NeighborhoodSoldDetails, Sibling } from "../types";
import { ImageWidth, Scalers } from "../constant";
import { addImageScaler, formatPrice, getCentrePoint, getZoomLevel } from "@/core";
@Component({
  components: {
    LazyImage,
  },
})
export default class NeighborhoodItem extends Vue {
  @Prop() coordinates: NeighborhoodPlatMap[];
  @Prop() sibling!: Sibling;
  @Prop() selectedNeighborhoodIds!: string[];
  @Prop() neighborhoodSoldPercentage!: number;
  @Prop() neighborhoodLotsCount!: number;
  @Prop() private soldPercentage!: NeighborhoodSoldDetails[];
  @Emit("sethoverNeighborZoomLevel")sethoverNeighborZoomLevel(zoomLevel: number, isDisableHoverNeighbor: boolean, centerMap: NeighboorhoodCoords){}
  @Emit("selectNeighborhood") emitSelectedNeighborhood (neighborhoodId: string) {}
  @Emit("hideSibling")hideSibling(){}
  @Emit('highlightNeighborhood')highlightNeighborhood(neighborhoodId: string, display: string){}
  addScaler(url) {
    return addImageScaler(url, Scalers.TN, ImageWidth.TN);
  }

  formatPrice(price: number) {
    return formatPrice(price);
  }

  selectNeighborhood() {
    if (this.neighborhoodLotsCount > 0) {
      this.emitSelectedNeighborhood(this.sibling.id);
    }
  }

  bestZoomClickNeighbor(){
    const hoveredNeighborhoodCoorfinates = this.coordinates.find((element) => element.id === this.sibling.id);
    const selectedNeighborhoodCoordinates = this.coordinates.find((element) => element.id === this.selectedNeighborhoodIds[0]);
    if(!!hoveredNeighborhoodCoorfinates &&
       !!selectedNeighborhoodCoordinates &&
       hoveredNeighborhoodCoorfinates.id !== selectedNeighborhoodCoordinates.id){
      const coordintes = [
        {
          latitude: hoveredNeighborhoodCoorfinates.latitude,
          longitude: hoveredNeighborhoodCoorfinates.longitude
        },
        {
          latitude: selectedNeighborhoodCoordinates.latitude,
          longitude: selectedNeighborhoodCoordinates.longitude
        }
      ]
      const mapSize = document.getElementsByClassName('vue-map-container')[0];
      const zoomLevel = getZoomLevel(coordintes,  mapSize.clientWidth, mapSize.clientHeight);
      const center = getCentrePoint(coordintes);
      this.sethoverNeighborZoomLevel(zoomLevel, false, center);
    }
  }
  highlightHoveredNeighborhood() {
    this.bestZoomClickNeighbor();
    const overlay = document.getElementById('Overlay-Rectangle');
    if(overlay){
      overlay.style.display = "flex";
    }
    this.soldPercentage.forEach((neighborhood) => {
      const element = document.getElementById(neighborhood.neighborhoodId);
      if(element){
        if(neighborhood.neighborhoodId === this.sibling.id) {
          element.style.display = "flex";
          this.highlightNeighborhood(neighborhood.neighborhoodId, "flex");
        }else{
          element.style.display = "none";
          this.highlightNeighborhood(neighborhood.neighborhoodId, "none");
        }
      }
    })
  }

  deselectNeighborhood() {
    const svg = document.getElementById('Overlay-Rectangle');
    if(svg){
      svg.style.display = "none";
    }
    this.sethoverNeighborZoomLevel(0, true,{latitude: 0, longitude: 0});
    this.hideSibling();
  }

  get isComingSoon () {
    return this.sibling.nb_unit_status?.toLowerCase().includes('coming soon');
  }
  get neighborhoodPriceShow() {
    return (!!+this.sibling.starting_price && !this.isComingSoon && this.neighborhoodSoldPercentage !== 100);
  }
}
